import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import IntegrationApi from '@/api/integration'
import { ImageInterface, placeholderLogo } from '@/utils/image'
import { integrationModuleEntity } from '@/models/models'
import { cloneDeep } from 'lodash'



@Module({ namespaced: true })
export default class IntegrationFormModule extends VuexModule {
    public isLoading: boolean = false
    public integrationModule: IntegrationModuleEntity = integrationModuleEntity
    public modulecategories: ModulecategoryEntity[] = []
    public modulepartners: ModulepartnerEntity[] = []
    public logo: ImageInterface = placeholderLogo

    @Mutation
    public setLoading(loading: boolean) {
        this.isLoading = loading
    }

    @Mutation
    public setIntegrationModule(integrationModule: IntegrationModuleEntity) {
        this.integrationModule = integrationModule
    }

    @Mutation
    public setModulecategories(modulescategories: ModulecategoryEntity[]) {
        this.modulecategories = modulescategories
    }

    @Mutation
    public setModulepartners(modulepartners: ModulepartnerEntity[]) {
        this.modulepartners = modulepartners
    }

    @Mutation
    public setLogo(logo: ImageInterface) {
        this.logo = logo
    }

    @Mutation
    public clearLogo() {
        this.logo = placeholderLogo
    }

    @Action
    public async getIntegrationModule(id: number) {
        this.context.commit('setLoading', true)

        const response = await IntegrationApi.getIntegration(id)

        if (response.status === 'cancelled') {
            return null
        }

        if (response.status === 'success') {
            this.context.commit('setIntegrationModule', response.data!.module)
            this.context.commit('setModulecategories', response.data!.categories)
            this.context.commit('setModulepartners', response.data!.partners)
        } else {
            alert(response.message)

            this.context.commit('setLoading', false)
            return null
        }

        this.context.commit('clearLogo')
        this.context.commit('setLoading', false)

        return (response.data && response.data.module) ? cloneDeep(response.data.module) : null
    }


    @Action
    public async saveIntegrationModule(entity: IntegrationModuleEntity): Promise<IntegrationModuleEntity | null> {
        const integrationModule = cloneDeep(entity)

        this.context.commit('setLoading', true)

        if (integrationModule.price!.trim() === '') {
            integrationModule.isDiscount = false
        }

        const response = await (integrationModule.id > 0 ?
            IntegrationApi.putIntegration(integrationModule) :
            IntegrationApi.postIntegration(integrationModule)
        )

        if (response.status !== 'success') {
            window.alert(response.message)

            this.context.commit('setLoading', false)
            return Promise.resolve(null)
        }

        if (response.data) {
            integrationModule.id = response.data!.module.id
        }

        if (integrationModule.id > 0 && this.logo.imageURL !== placeholderLogo.imageURL) {
            const uploadResponse = await IntegrationApi.uploadIntegrationLogo(integrationModule.id, this.logo)

            if (uploadResponse.status !== 'success') {
                window.alert(uploadResponse.message)

                this.context.commit('setLoading', false)
                return Promise.resolve(null)
            }
        }

        this.context.commit('setLoading', false)

        return Promise.resolve(integrationModule)
    }
}
